<script lang="ts">
   import type { Colour } from '.';

   interface Props {
      value1?: Colour,
      value2?: Colour,
      value3?: Colour,
      multiplier?: Colour,
      tolerance?: Colour
   }

   let { value1, value2, value3, multiplier, tolerance }: Props = $props();

   function hexToRgb(hex: string) {
      const r = parseInt(hex.substring(1, 3), 16);
      const g = parseInt(hex.substring(3, 5), 16);
      const b = parseInt(hex.substring(5, 7), 16);
      return { r, g, b };
   }

   function rgbToHex(r: number, g: number, b: number) {
      const toHex = (c: number) => `0${c.toString(16)}`.slice(-2);
      return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
   }

   function darken(colour: string, percent: number) {
      const { r, g, b } = hexToRgb(colour);
      return rgbToHex(
         Math.min(255, Math.round(r * percent)),
         Math.min(255, Math.round(g * percent)),
         Math.min(255, Math.round(b * percent))
      );
   }
</script>

<!-- <?xml version="1.0" encoding="UTF-8" standalone="no"?> -->
<!-- Created with Inkscape (http://www.inkscape.org/) -->
<!-- <svg width="2080.9143" height="283.87521"> -->
<svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 1018.0572 283.87521">
  <g transform="translate(-525.18201,-200.4222)">
    <g>
      <rect
         y="318.11612"
         x="525.18201"
         height="48.487324"
         width="1018.0572"
         style="fill:#666666" />
      <path
         d="m 798.5625,200.9222 c -21.47944,0 -37.32619,4.0094 -49.46875,10.5625 -0.0526,0.028 -0.10377,0.065 -0.15625,0.094 -18.04664,8.9915 -27.35769,22.7119 -33.90625,37.4374 -14.51122,27.7533 -22.11341,59.0945 -55.8125,69.0938 -1.31397,0.3899 -2.62206,0.7469 -3.9375,1.125 v 46.2188 c 1.31639,0.3788 2.62251,0.766 3.9375,1.1562 64.74738,19.2121 12.93753,117.1875 139.34375,117.1875 0.73556,0 1.52761,-0.033 2.3125,-0.062 1.42733,0.029 2.86724,0.062 4.34375,0.062 30.2139,0 103.1066,-25.625 131.1875,-25.625 h 185.24995 c 28.081,0 100.9736,25.625 131.1876,25.625 1.4764,0 2.9164,-0.034 4.3437,-0.062 0.7849,0.03 1.5769,0.062 2.3125,0.062 126.4062,0 74.5964,-97.9754 139.3438,-117.1875 1.3149,-0.3902 2.6211,-0.7774 3.9374,-1.1562 v -46.2188 c -1.3154,-0.3781 -2.6235,-0.7351 -3.9374,-1.125 -33.6993,-9.9993 -41.3013,-41.3405 -55.8126,-69.0938 -6.5485,-14.7255 -15.8596,-28.4459 -33.9062,-37.4374 -0.053,-0.029 -0.1037,-0.065 -0.1562,-0.094 -12.1426,-6.5531 -27.9894,-10.5625 -49.4688,-10.5625 -0.7233,0 -1.4833,0.034 -2.25,0.062 -1.4474,-0.029 -2.9088,-0.062 -4.4062,-0.062 -30.214,0 -103.1066,25.625 -131.1876,25.625 H 936.40625 c -28.0809,0 -100.9736,-25.625 -131.1875,-25.625 -1.49753,0 -2.95885,0.034 -4.40625,0.062 -0.76674,-0.029 -1.52669,-0.062 -2.25,-0.062 z"
         style="fill:#d9bb7a;stroke:#565248;stroke-width:1" />
      {#if value1}
         <path
            d="m 798.5625,200.9222 c -3.72253,0 -7.26204,0.11053 -10.65625,0.34375 V 483.5472 c 3.40707,0.16398 6.95023,0.25 10.65625,0.25 0.73556,0 1.52761,-0.0335 2.3125,-0.0625 1.42733,0.029 2.86724,0.0625 4.34375,0.0625 12.13427,0 31.17182,-4.14734 51.40625,-9.09375 v -264.6875 c -20.23443,-4.94641 -39.27198,-9.09375 -51.40625,-9.09375 -1.49753,0 -2.95885,0.0345 -4.40625,0.0625 -0.76674,-0.029 -1.52669,-0.0625 -2.25,-0.0625 z"
            style="stroke-width:1"
            style:fill={value1.bgColour}
            style:stroke={darken(value1.bgColour, 0.50)} />
      {/if}
      {#if value2}
         <path
            d="m 901.0625,220.9222 v 242.875 c 14.2546,-3.26548 26.85853,-5.625 35.34375,-5.625 H 969.75 v -231.625 h -33.34375 c -8.48522,0 -21.08915,-2.35952 -35.34375,-5.625 z"
            style="stroke-width:1"
            style:fill={value2.bgColour}
            style:stroke={darken(value2.bgColour, 0.50)} />
      {/if}
      {#if value3}
         <path
            d="m 1014.1875,226.5472 v 231.625 h 68.6875 v -231.625 z"
            style="stroke-width:1"
            style:fill={value3.bgColour}
            style:stroke={darken(value3.bgColour, 0.50)} />
      {/if}
      {#if multiplier}
         <path
            d="M 1195.8324 211.389 C 1170.3371 217.71978 1143.7594 224.84052 1127.1449 226.28353 L 1127.1449 458.43587 C 1143.7594 459.87888 1170.3371 466.99962 1195.8324 473.3304 L 1195.8324 211.389 z "
            style="stroke-width:1"
            style:fill={multiplier.bgColour}
            style:stroke={darken(multiplier.bgColour, 0.50)} />
      {/if}
      {#if tolerance}
         <path
            d="m 1252.8438,200.9222 c -6.488,0 -14.9424,1.20677 -24.5,3.0625 v 276.75 c 9.5576,1.85573 18.012,3.0625 24.5,3.0625 1.4764,0 2.9164,-0.0345 4.3437,-0.0625 0.7849,0.03 1.5769,0.0625 2.3125,0.0625 14.8045,0 27.1423,-1.34611 37.5312,-3.75 V 206.3597 c -10.1889,-3.43912 -22.4657,-5.4375 -37.5312,-5.4375 -0.7233,0 -1.4833,0.0345 -2.25,0.0625 -1.4474,-0.029 -2.9089,-0.0625 -4.4062,-0.0625 z"
            style="stroke-width:1"
            style:fill={tolerance.bgColour}
            style:stroke={darken(tolerance.bgColour, 0.50)} />
      {/if}
    </g>
  </g>
</svg>